export const getLanguageCode = (locale: string) => {
  // Regex pattern: two lowercase letters, mandatory hyphen, two uppercase letters
  const localePattern = /^[a-z]{2}-[A-Z]{2}$/i;

  if (!locale || typeof locale !== 'string') return 'en';

  const normalizedLocale = locale.trim();

  // Check if format matches
  if (!localePattern.test(normalizedLocale)) return 'en';

  return normalizedLocale.split('-')[0].toLowerCase();
};

export const getCountryCode = (locale: string) => locale.split('-')[1]?.toUpperCase();
